import { ProjectSubmitMapper } from 'mapper/ProjectSubmitMapper';

import { answerMapper } from './answerMapper';

export const projectSubmitMapper = new ProjectSubmitMapper(answerMapper);
